import axios, { AxiosResponse } from "axios";
import { multiFranchiseAxios } from '../axios/multiFranchiseAxios';
import { IChangePasswordFormValues } from "../../components/global/Modal/ChangePasswordModal";
import md5 from 'md5';
export interface IAPILoginAuthProps {
    username: string;
    password: string;
}

export async function APILoginAuth(props: IAPILoginAuthProps): Promise<AxiosResponse> {
    let body = props as IAPILoginAuthProps;

    try {
        let respone: AxiosResponse = await axios.post("/auth/login", body);
        return respone.data;
    } catch (error) {
        throw error
    }
}

export async function APIFarmBookLoginAuth(props: IAPILoginAuthProps): Promise<AxiosResponse> {
    let body = {
        "fn": "login",
        "credentialData": {
            "email": props.username,
            "password": props.password,
            "service": "demandplaning"
        }
    }

    try {
        let respone: AxiosResponse = await multiFranchiseAxios.post("/sso/authAPI", body);
        return respone.data;
    } catch (error) {
        throw new Error(`Error At APIFarmBookLoginAuth : ${error}`);
    }
}

export async function APILogoutAuth() {
    try {
        let result: AxiosResponse = await axios.get("/");
        return result.data;
    } catch (error) {
        throw new Error(`Error At APILogoutAuth : ${error}`);
    }
}

export async function APIChangePassword(payload:IChangePasswordFormValues) {

    console.debug(payload,'@@payload')

    let body = {
        oldPassword:md5(payload.old_password),
        newPassword:md5(payload.new_password)
    }

    try {
        let result: AxiosResponse = await axios.post("/user/updatePassword",body);
        return result.data;
    } catch (error) {
        throw new Error(`Error At APIChangePassword : ${error}`);
    }
}

export async function APIGetUserInfoByToken() {
    try {
        let result: AxiosResponse = await axios.get("/auth/user-info");
        return result.data;
    } catch (error) {
        throw new Error(`Error At APIGetUserInfoByToken : ${error}`);
    }
}
